import { createSlice } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'

export const remoteConfigDefaultValues = {
  is_web_subscription_enabled: false,
  is_web_phone_verification_enabled: false,
}

const initialState = remoteConfigDefaultValues

export const remoteConfigSlice = createSlice({
  name: 'remoteConfig',
  initialState,
  reducers: {
    setRemoteConfig: (state, action) => {
      return action.payload
    },
  },
})

export const selectRemoteConfig = (state): typeof initialState =>
  state.remoteConfig

export const useRemoteConfig = () => useSelector(selectRemoteConfig)

export const { setRemoteConfig } = remoteConfigSlice.actions

export default remoteConfigSlice.reducer
